'use client'

import { useHCRouter } from '@/components/HCNextLink'
import styles from './index.module.scss'
import { isInApp } from 'core/utils/appBridge'

type ApptopProps = {
  title: string
}

export const PhoneTop = ({ title }: ApptopProps) => {
  const router = useHCRouter()

  const back = () => {
    router.back()
  }

  const toLogin = () => {
    router.push('/login')
  }

  if (isInApp()) return null

  return (
    <div className={styles.phoneTop}>
      <i onClick={back} className="iconfont iconyoujiantou  "></i>
      <div className={styles.title}>{title}</div>
      <i onClick={toLogin} className="iconfont iconn-guanbi "></i>
    </div>
  )
}
